var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloud = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 13,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  d: "M9.811 6.961q-.265 0-.524.055a2.893 2.893 0 1 0-5.692.982 2.014 2.014 0 1 0-.33 4h6.546a2.518 2.518 0 0 0 0-5.035zM12.392 6.205a2.768 2.768 0 0 0-4.479-3.02"
})));
export default SvgCloud;